<h1 mat-dialog-title>
	{{successfulOrders?.length}} of your {{successfulOrders?.length + failedOrders?.length}} orders were submitted
	successfully
</h1>
<mat-dialog-content>
	<div fxLayout="column" fxLayoutAlign="start">
		<div *ngIf="failedOrders.length > 0">
			<p>The orders that failed to submit are still in your cart and can be re-tried.</p>
		</div>
		<div *ngIf="successfulOrders.length > 0" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="5px">
			<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="15px">
				<div class="label">Successful Orders</div>
				<div>
					<a (click)="closeModal()" [routerLink]="['/track-order', {trackingId: allOrderIds, startDate: startDate, endDate: endDate}]" color="primary"
					   mat-button>
						Track All
					</a>
				</div>
			</div>
			<div *ngFor="let x of successfulOrders" class="bottom-border-row" fxLayout="row wrap"
				 fxLayoutAlign="space-between center" fxLayoutGap="15px">
				<div>{{ x.id }}</div>
				<div>
					<button [color]="'primary'" [matMenuTriggerFor]="actionMenu" mat-icon-button>
						<mat-icon>list</mat-icon>
					</button>
					<mat-menu #actionMenu="matMenu">
						<button (click)="closeModal()" [routerLink]="['/track-order', {trackingId: x.id, startDate: x.readyTimeFrom}]"
								mat-menu-item>
							{{ 'placeOrderView.showTrackingInfoActionText' | translate }}
						</button>
					</mat-menu>
				</div>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
		<span>Close</span>
	</button>
</mat-dialog-actions>
